import { Injectable } from '@angular/core';
import { ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class ValidationService {

  constructor() { }

  static getValidatorErrorMessage(validatorName: string, validatorValue?: any) {
    let config = {
      'required': 'Required',
      'invalidCreditCard': 'Is invalid credit card number',
      'email': 'Invalid email address',
      'invalidPassword': 'Invalid password. Password must be at least 6 characters long, and contain a number.',
      'minlength': `Minimum length ${validatorValue.requiredLength}`
    };

    return config[validatorName];
  }

  static creditCardValidator(control) {
    // Visa, MasterCard, American Express, Diners Club, Discover, JCB
    if (control.value.match(/^(?:4[0-9]{12}(?:[0-9]{3})?|5[1-5][0-9]{14}|6(?:011|5[0-9][0-9])[0-9]{12}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|(?:2131|1800|35\d{3})\d{11})$/)) {
      return null;
    } else {
      return { 'invalidCreditCard': true };
    }
  }

  static emailValidator(control) {
    // RFC 2822 compliant regex
    if (!control.value || control.value.match(/^[A-Za-z0-9]+[A-Za-z0-9._-]+@[A-Za-z0-9-]+\..+$/)) {
      return null;
    } else {
      return { 'email': true };
    }
  }

  static passwordValidator(control) {
    // {6,100}           - Assert password is between 6 and 100 characters
    // (?=.*[0-9])       - Assert a string has at least one number
    if (control.value.match(/^(?=.*[0-9])[a-zA-Z0-9!@#$%^&*]{6,100}$/)) {
      return null;
    } else {
      return { 'invalidPassword': true };
    }
  }



  static confirmPasswordValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {

    if (!control.parent || !control) {
      return null;
    }
    const password = control.parent.get('password');
    const passwordConfirm = control.parent.get('confirmPassword');

    if (!password || !passwordConfirm) {
      return null;
    }
    if (passwordConfirm.value === '') {
      return null;
    }
    if (password.value === passwordConfirm.value) {
      return null;
    }
    return { 'passwordsNotMatching': true };
  };

  static autoCompleteValueSelected(myArray: any[], listFiledName: string): ValidatorFn {
    return (c: AbstractControl): { [key: string]: boolean } | null => {
      let textboxValue = c.value;
      let selectboxValue = c.value ? c.value[listFiledName] : '';
      selectboxValue = selectboxValue || "";
      let pickedOrNot = myArray.filter(alias => alias[listFiledName] === selectboxValue);

      if (pickedOrNot.length > 0) {
        // everything's fine. return no error. therefore it's null.
        return null;
      } else if (!textboxValue) {
        return null;
      } else {
        //there's no matching selectboxvalue selected. so return match error.
        return { 'mat-require-match': true };
      }
    }
  }

  static isStrongPassword(isStrongPassword: boolean): ValidatorFn {
    return (c: AbstractControl): { [key: string]: boolean } | null => {
      if (isStrongPassword) {
        return null;
      } else {
        return { 'mat-require-strong-pwd': true };
      }
    }
  } 

}

